import request from '@/utils/request'

var api = {
  //openid登录
  login(data){
    return request({
      url: 'group/Account/login',
      method: 'post',
      data: data
    })
  },
  //退出
  out(data){
    return request({
      url: 'group/User/out',
      method: 'post',
      data: data
    })
  },
  //用户信息
  getInfo(){
    return request({
      url: 'group/User/info',
      method: 'get',
    })
  },
  //社区信息
  submitCommunity(){
    return request({
      url: 'group/User/submitCommunity',
      method: 'post',
      data: data
    })
  },
  //充值
  recharge(data){
    return request({
      url: 'group/User/recharge',
      method: 'post',
      data: data
    })
  },
  //充值
  submitStoreGoodsPrice(data){
    return request({
      url: 'group/User/submitStoreGoodsPrice',
      method: 'post',
      data: data
    })
  },
  //下级门店加工价格
  storeGoodsPrice(data){
    return request({
      url: 'group/User/storeGoodsPrice',
      method: 'get',
      params: data
    })
  },
  //检测是否绑定社区
  checkCid(){
    return request({
      url: 'group/User/checkCid',
      method: 'get',
    })
  },
  //获取账号密码
  account(){
    return request({
      url: 'group/User/account',
      method: 'get',
    })
  },
  //修改密码
  password(data){
    return request({
      url: 'group/User/password',
      method: 'post',
      data: data
    })
  },
  //获取权限配置
  getAccess(){
    return request({
      url: 'group/User/getAccess',
      method: 'post',
    })
  },
  //登录小区
  loginCommunity(data){
    return request({
      url: 'group/Account/loginCommunity',
      method: 'post',
      data: data
    })
  },
  //订单数量
  getOrderCount(data){
    return request({
      url: 'group/User/getOrderCount',
      method: 'get',
      params:data
    })
  },
  //下级订单数量
  getSubOrderCount(data){
    return request({
      url: 'group/User/getSubOrderCount',
      method: 'get',
      params:data
    })
  },
  //订单列表
  getOrderLists(data){
    return request({
      url: 'group/User/getOrderLists',
      method: 'get',
      params:data
    })
  },
  //下级订单列表
  getSubOrderLists(data){
    return request({
      url: 'group/User/getSubOrderLists',
      method: 'get',
      params:data
    })
  },
  //订单列表
  orderDetial(data){
    return request({
      url: 'group/User/orderDetial',
      method: 'get',
      params:data
    })
  },
  //修改上门时间
  editHomeTime(data){
    return request({
      url: 'group/User/editHomeTime',
      method: 'post',
      data:data
    })
  },
  //扫码签名
  wxSign(data){
    return request({
      url: 'group/User/wxSign',
      method: 'get',
      params:data
    })
  },
  //确认收衣
  collect(data){
    return request({
      url: 'group/User/collect',
      method: 'post',
      data: data
    })
  },
  //获取入库订单
  getOrder(data){
    return request({
      url: 'group/User/getOrder',
      method: 'get',
      params: data
    })
  },
  //商品入库
  factoryHouse(data){
    return request({
      url: 'group/User/factoryHouse',
      method: 'post',
      data: data
    })
  },
  //订单入库
  wareHouse(data){
    return request({
      url: 'group/User/wareHouse',
      method: 'post',
      data: data
    })
  },
  //出库订单
  getOutOrder(data){
    return request({
      url: 'group/User/getOutOrder',
      method: 'get',
      params: data
    })
  },
  //出库
  outHouse(data){
    return request({
      url: 'group/User/outHouse',
      method: 'post',
      data: data
    })
  },
  //状态改变
  changeStatus(data){
    return request({
      url: 'group/User/changeStatus',
      method: 'post',
      data: data
    })
  },
  //获取师傅
  getWorker(data){
    return request({
      url: 'group/User/getWorker',
      method: 'get',
      params: data
    })
  },
  //查看评价
  getComment(data){
    return request({
      url: 'group/User/getComment',
      method: 'get',
      params: data
    })
  },
  //收益明细
  orderRebate(data){
    return request({
      url: 'group/User/orderRebate',
      method: 'get',
      params:data
    })
  },
  //提现金额
  withdrawMoney(data){
    return request({
      url: 'group/User/withdrawMoney',
      method: 'post',
      data:data
    })
  },
  //可提现记录
  withdrawList(data){
    return request({
      url: 'group/User/withdrawList',
      method: 'get',
      params:data
    })
  },
  //中转仓可提现
  warehouseWithdrawList(data){
    return request({
      url: 'group/User/warehouseWithdrawList',
      method: 'get',
      params:data
    })
  },
  //提现记录
  withdrawRecord(data){
    return request({
      url: 'group/User/withdrawRecord',
      method: 'get',
      params:data
    })
  },
  //提现申请
  submitWithdraw(data){
    return request({
      url: 'group/User/submitWithdraw',
      method: 'post',
      data:data
    })
  },
  //余额变动记录
  balanceList(data){
    return request({
      url: 'group/User/balanceList',
      method: 'get',
      params:data
    })
  },
  //团长收益
  groupRebate(){
    return request({
      url: 'group/User/groupRebate',
    })
  },
  //获取小区
  getCommunity(data){
    return request({
      url: 'group/User/getCommunity',
      params: data
    })
  },
  //社区所有操作员
  communityOperater(){
    return request({
      url: 'group/User/communityOperater',
    })
  },
  //小区收衣数据
  communityData(data){
    return request({
      url: 'group/User/communityData',
      params: data
    })
  },
  //呼叫跑腿配送
  uuptOrder(data){
    return request({
      url: 'group/User/uuptOrder',
      method: 'post',
      data:data
    })
  },
  //取消跑腿配送
  cancelUuptOrder(data){
    return request({
      url: 'group/User/cancelUuptOrder',
      method: 'post',
      data:data
    })
  },
  storeApply(data){
    return request({
      url: 'group/Account/storeApply',
      method: 'post',
      data:data
    })
  },
  problem(data){
    return request({
      url: 'group/User/problem',
      method: 'post',
      data:data
    })
  },
  // wxSign1(data){
  //   return request({
  //     url: 'group/User/wxSign1',
  //     method: 'get',
  //     params:data
  //   })
  // },
  uploadsImg(data){
    return request({
      url: 'group/User/uploadsImg',
      method: 'post',
      data:data
    })
  },
  //我的下级
  myInvite(data){
    return request({
      url: 'group/User/myInvite',
      method: 'get',
      params:data
    })
  },
  //我的推广
  inviteUser(data){
    return request({
      url: 'group/User/inviteUser',
      method: 'get',
      params:data
    })
  },
  //二级BD
  getSecondBd(data){
    return request({
      url: 'group/User/getSecondBd',
      method: 'get',
      params:data
    })
  },
  //编辑二级BD
  submitSecondBd(data){
    return request({
      url: 'group/User/submitSecondBd',
      method: 'post',
      data:data
    })
  },
  //组员推广
  groupInvite(data){
    return request({
      url: 'group/User/groupInvite',
      method: 'get',
      params:data
    })
  },
  //下级团长添加
  submitSecondCommunity(data){
    return request({
      url: 'group/User/submitSecondCommunity',
      method: 'post',
      data:data
    })
  },
  //下级团长
  getSecondCommunity(data){
    return request({
      url: 'group/User/getSecondCommunity',
      method: 'get',
      params:data
    })
  },
  //下级团长收益
  secondCommunityReward(data){
    return request({
      url: 'group/User/secondCommunityReward',
      method: 'get',
      params:data
    })
  },
  //拜访记录
  visit(data){
    return request({
      url: 'group/User/visit',
      method: 'get',
      params:data
    })
  },
  //新增拜访记录
  submitVisit(data){
    return request({
      url: 'group/User/submitVisit',
      method: 'post',
      data:data
    })
  },
  //拜访标签
  visitLabels(data){
    return request({
      url: 'group/User/visitLabels',
      method: 'get',
      params:data
    })
  },
  //收入统计
  countReward(data){
    return request({
      url: 'group/User/countReward',
      method: 'get',
      params:data
    })
  },
  //获取小程序码
  qrcode(){
    return request({
      url: 'group/User/qrcode',
      method: 'get',
    })
  },
  //超时订单
  outTimeOrder(data){
    return request({
      url: 'group/User/outTimeOrder',
      method: 'get',
      params:data
    })
  },
  //下级超时订单
  suboutTimeOrder(data){
    return request({
      url: 'group/User/suboutTimeOrder',
      method: 'get',
      params:data
    })
  },


  //商品搜索
  searchProduct(data){
    return request({
      url: 'group/Product/searchProduct',
      method: 'get',
      params:data
    })
  },
  //分类
  category(){
    return request({
      url: 'group/Product/category',
      method: 'get',
    })
  },
  //添加商品
  submitProduct(data){
    return request({
      url: 'group/Product/submitProduct',
      method: 'post',
      data:data
    })
  },
  //修改扎代码
  editBag(data){
    return request({
      url: 'group/User/editBag',
      method: 'post',
      data:data
    })
  },
  //商品列表
  productList(data){
    return request({
      url: 'group/Product/productList',
      method: 'get',
      params:data
    })
  },
  //商品详情
  productDetial(data){
    return request({
      url: 'group/Product/productDetial',
      method: 'get',
      params:data
    })
  },
  //商品详情
  changeProductStatus(data){
    return request({
      url: 'group/Product/changeProductStatus',
      method: 'post',
      data:data
    })
  },
  //工单分类
  workCategory(data){
    return request({
      url: 'group/Work/category',
      method: 'get',
      params:data
    })
  },
  //提交工单
  submitWork(data){
    return request({
      url: 'group/Work/submitWork',
      method: 'post',
      data:data
    })
  },
  //工单统计
  workCount(data){
    return request({
      url: 'group/Work/workCount',
      method: 'get',
      params:data
    })
  },
  //工单列表
  workOrder(data){
    return request({
      url: 'group/Work/workOrder',
      method: 'get',
      params:data
    })
  },
  //工单详情
  workOrderInfo(data){
    return request({
      url: 'group/Work/workOrderInfo',
      method: 'get',
      params:data
    })
  },
  //工单处理办法
  submitSolution(data){
    return request({
      url: 'group/Work/submitSolution',
      method: 'post',
      data:data
    })
  },
  //工单处理标签
  workLabels(data){
    return request({
      url: 'group/Work/labels',
      method: 'get',
      params:data
    })
  },
  //工单回复
  submitWorkReply(data){
    return request({
      url: 'group/Work/submitWorkReply',
      method: 'post',
      data:data
    })
  },
  //获取工单回复
  workOrderReply(data){
    return request({
      url: 'group/Work/workOrderReply',
      method: 'get',
      params:data
    })
  },
  //客服接收快捷回复
  quickReply(){
    return request({
      url: 'group/Work/quickReply',
      method: 'get',
    })
  },
  //工单状态
  changeWorkStatus(data){
    return request({
      url: 'group/Work/changeWorkStatus',
      method: 'post',
      data:data
    })
  },
  //衣物状态
  clotheStatus(data){
    return request({
      url: 'group/Work/clotheStatus',
      method: 'get',
      params:data
    })
  },
  //门店列表
  store(){
    return request({
      url: 'group/Work/store',
      method: 'get',
    })
  },
  //客服列表
  getService(){
    return request({
      url: 'group/Work/service',
      method: 'get',
    })
  },
  //分配客服
  assignService(data){
    return request({
      url: 'group/Work/assignService',
      method: 'post',
      data: data,
    })
  },
  //司机
  driverList(data){
    return request({
      url: 'group/driver/driverList',
      method: 'get',
      params: data,
    })
  },
  //编辑司机
  submitDriver(data){
    return request({
      url: 'group/driver/submitDriver',
      method: 'post',
      data: data,
    })
  },
  //待取件
  waitPickup(data){
    return request({
      url: 'group/driver/waitPickup',
      method: 'get',
      params: data,
    })
  },
  //取件
  pickup(data){
    return request({
      url: 'group/driver/pickup',
      method: 'post',
      data: data,
    })
  },
  //出厂订单
  getFactoryOrder(data){
    return request({
      url: 'group/driver/getFactoryOrder',
      method: 'get',
      params: data,
    })
  },
  getExpressOrder(data){
    return request({
      url: 'group/driver/getExpressOrder',
      method: 'get',
      params: data,
    })
  },
  //快递下单
  submitExpress(data){
    return request({
      url: 'group/driver/submitExpress',
      method: 'post',
      data: data,
    })
  },
  submitFactory(data){
    return request({
      url: 'group/driver/submitFactory',
      method: 'post',
      data: data,
    })
  },
  //商品配送提交
  submitDelivery(data){
    return request({
      url: 'group/driver/submitDelivery',
      method: 'post',
      data: data,
    })
  },
  //物流统计
  driverData(data){
    return request({
      url: 'group/driver/driverData',
      method: 'get',
      params: data,
    })
  },
  //物流统计2
  driverData2(data){
    return request({
      url: 'group/driver/driverData2',
      method: 'get',
      params: data,
    })
  },
  //已取件
  pickuped(data){
    return request({
      url: 'group/driver/pickuped',
      method: 'get',
      params: data,
    })
  },
  //已到站
  arrivaled(data){
    return request({
      url: 'group/driver/arrivaled',
      method: 'get',
      params: data,
    })
  },
  //上挂
  up(data){
    return request({
      url: 'group/user/up',
      method: 'post',
      data: data,
    })
  },
  //待取详情
  waitPickupInfo(data){
    return request({
      url: 'group/driver/waitPickupInfo',
      method: 'get',
      params: data,
    })
  },
  //待入厂
  waitInFactory(data){
    return request({
      url: 'group/factorys/waitInFactory',
      method: 'get',
      params: data,
    })
  },
  backwash(data){
    return request({
      url: 'group/factorys/backwash',
      method: 'get',
      params: data,
    })
  },
  inFactory(data){
    return request({
      url: 'group/factorys/inFactory',
      method: 'post',
      data: data,
    })
  },
  factoryData(data){
    return request({
      url: 'group/factorys/factoryData',
      method: 'get',
      params: data,
    })
  },
  barOrder(data){
    return request({
      url: 'group/factorys/barOrder',
      method: 'get',
      params: data,
    })
  },
  searchOrder(data){
    return request({
      url: 'group/factorys/searchOrder',
      method: 'get',
      params: data,
    })
  },
  alliInFactory(data){
    return request({
      url: 'group/factorys/alliInFactory',
      method: 'post',
      data: data,
    })
  },
   //不洗退回
   factoryBack(data){
    return request({
      url: 'group/factorys/factoryBack',
      method: 'post',
      data: data,
    })
  },
  getProductOrder(data){
    return request({
      url: 'group/user/getProductOrder',
      method: 'get',
      params: data,
    })
  },
  submitProductQrcode(data){
    return request({
      url: 'group/user/submitProductQrcode',
      method: 'post',
      data: data,
    })
  },
  getUser(data){
    return request({
      url: 'group/user/getUser',
      method: 'get',
      params: data,
    })
  },
  submitActive(data){
    return request({
      url: 'group/user/submitActive',
      method: 'post',
      data: data,
    })
  },
  //昨天出厂
  yesterdayOutFactory(data){
    return request({
      url: 'group/user/yesterdayOutFactory',
      method: 'get',
      params: data,
    })
  },
  //历史出厂未到店
  outFactoryList(data){
    return request({
      url: 'group/user/outFactoryList',
      method: 'get',
      params: data,
    })
  },
  //历史已回店
  historyBackStore(data){
    return request({
      url: 'group/user/historyBackStore',
      method: 'get',
      params: data,
    })
  },
  //扫回店
  backStore(data){
    return request({
      url: 'group/user/backStore',
      method: 'post',
      data: data,
    })
  },
  //录单查代码查询
  getRecordOrder(data){
    return request({
      url: 'group/Record/getOrder',
      method: 'get',
      params: data,
    })
  },
  //录单扎代码查询
  submitRecord(data){
    return request({
      url: 'group/Record/submitRecord',
      method: 'post',
      data: data,
    })
  },
  //录单记录
  washCode(data){
    return request({
      url: 'group/Record/washCode',
      method: 'get',
      params: data,
    })
  },
  //录单查代码查询
  uploadsImgOss(data){
    return request({
      url: 'group/User/uploadsImgOss',
      method: 'post',
      data: data,
    })
  },
  //送洗
  sendFactory(data){
    return request({
      url: 'group/Record/submitFactory',
      method: 'post',
      data: data,
    })
  },
  //送洗工厂
  getFactory(data){
    return request({
      url: 'group/Record/getFactory',
      method: 'get',
      params: data,
    })
  },
  //顾客取衣
  waitPick(data){
    return request({
      url: 'group/Record/waitPick',
      method: 'get',
      params: data,
    })
  },
  //顾客取衣
  pickClothe(data){
    return request({
      url: 'group/Record/pick',
      method: 'post',
      data: data,
    })
  },
  //附件补录
  getAnnex(data){
    return request({
      url: 'group/Record/annex',
      method: 'get',
      params: data,
    })
  },
 
  //附件补录
  submitAnnex(data){
    return request({
      url: 'group/Record/submitAnnex',
      method: 'post',
      data: data,
    })
  },
 
  //获取同订单录单数据
  getWashCode(data){
    return request({
      url: 'group/Record/getWashCode',
      method: 'get',
      params: data,
    })
  },
  //撤单
  cancelRecord(data){
    return request({
      url: 'group/Record/cancelOrder',
      method: 'post',
      data: data,
    })
  },
 
  //获取进出厂数据
  getInOutFactoryData(data){
    return request({
      url: 'group/Home/getInOutFactoryData',
      method: 'get',
      params: data,
    })
  },
  //获取进出厂门店数据
  getInOutFactoryCommunity(data){
    return request({
      url: 'group/Home/community',
      method: 'get',
      params: data,
    })
  },
  //异常衣物类型
  abnormal(data){
    return request({
      url: 'group/Home/abnormal',
      method: 'get',
      params: data,
    })
  },
  //异常衣物报备
  submitAbnormal(data){
    return request({
      url: 'group/factorys/submitAbnormal',
      method: 'post',
      data: data,
    })
  },
  //优惠券
  communityCoupon(data){
    return request({
      url: 'group/user/communityCoupon',
      method: 'get',
      params: data,
    })
  },
  //社区用户
  getCommunityUser(data){
    return request({
      url: 'group/user/getCommunityUser',
      method: 'get',
      params: data,
    })
  },
  //社区用户
  giveCoupon(data){
    return request({
      url: 'group/user/giveCoupon',
      method: 'post',
      data: data,
    })
  },
  //社区用户
  subQrCoupon(data){
    return request({
      url: 'group/user/subQrCoupon',
      method: 'post',
      data: data,
    })
  },
  //社区用户
  goodsCount(data){
    return request({
      url: 'group/user/goodsCount',
      method: 'get',
      params: data,
    })
  },
  //社区用户
  goodsAmountCount(data){
    return request({
      url: 'group/user/goodsAmountCount',
      method: 'get',
      params: data,
    })
  },
  //社区用户
  goodsGroupCount(data){
    return request({
      url: 'group/user/goodsGroupCount',
      method: 'get',
      params: data,
    })
  },
  //社区用户
  goodsCountExport(data){
    return request({
      url: 'group/user/goodsCountExport',
      method: 'get',
      params: data,
    })
  },
  //社区用户
  goodsAmountCountExport(data){
    return request({
      url: 'group/user/goodsAmountCountExport',
      method: 'get',
      params: data,
    })
  },
  //社区用户
  goodsGroupCountExport(data){
    return request({
      url: 'group/user/goodsGroupCountExport',
      method: 'get',
      params: data,
    })
  },
  //会员统计
  getCountMember(data){
    return request({
      url: 'group/user/getCountMember',
      method: 'get',
      params: data,
    })
  },
  //会员统计
  cardMember(data){
    return request({
      url: 'group/user/cardMember',
      method: 'get',
      params: data,
    })
  },
  clothesConfirmList(data){
    return request({
      url: 'group/user/clothesConfirmList',
      method: 'get',
      params: data,
    })
  },
  clothesConfirmInfo(data){
    return request({
      url: 'group/user/clothesConfirmInfo',
      method: 'get',
      params: data,
    })
  },
  submitClothesConfirm(data){
    return request({
      url: 'group/user/submitClothesConfirm',
      method: 'post',
      data: data,
    })
  },
  submitClothesConfirmPush(data){
    return request({
      url: 'group/user/submitClothesConfirmPush',
      method: 'post',
      data: data,
    })
  },
  submitClothesConfirmContent(data){
    return request({
      url: 'group/user/submitClothesConfirmContent',
      method: 'post',
      data: data,
    })
  },
  getDouYinOrder(data){
    return request({
      url: 'group/user/getDouYinOrder',
      method: 'get',
      params: data,
    })
  },
  douYinVerify(data){
    return request({
      url: 'group/user/douYinVerify',
      method: 'post',
      data: data,
    })
  },
  exportWashCode(data){
    return request({
      url: 'group/user/exportWashCode',
      method: 'post',
      data: data,
    })
  },
  editWashCode(data){
    return request({
      url: 'group/user/editWashCode',
      method: 'post',
      data: data,
    })
  },
  //获取上一条用户信息
  getLastUserInfo(data){
    return request({
      url: 'group/Record/getLastUserInfo',
      method: 'get',
      params: data,
    })
  },
  getClotheCount(data){
    return request({
      url: 'group/Record/getClotheCount',
      method: 'get',
      params: data,
    })
  },
  operatePhoto(data){
    return request({
      url: 'group/Record/operatePhoto',
      method: 'post',
      data: data,
    })
  },
  bindBox(data){
    return request({
      url: 'group/user/bindBox',
      method: 'post',
      data: data,
    })
  },
  unbindBox(data){
    return request({
      url: 'group/user/unbindBox',
      method: 'post',
      data: data,
    })
  },
  getBoxList(data){
    return request({
      url: 'group/user/getBoxList',
      method: 'get',
      params: data,
    })
  },
  qrcodeBox(data){
    return request({
      url: 'group/user/qrcodeBox',
      method: 'get',
      params: data,
    })
  },
  getCurtainGoods(data){
    return request({
      url: 'group/curtain/getCurtainGoods',
      method: 'get',
      params: data,
    })
  },
  submitCurtainGoods(data){
    return request({
      url: 'group/curtain/submitCurtainGoods',
      method: 'post',
      data: data,
    })
  },
  changeCurtainGoodsStatus(data){
    return request({
      url: 'group/curtain/changeCurtainGoodsStatus',
      method: 'post',
      data: data,
    })
  },
  submitCurtainOrder(data){
    return request({
      url: 'group/curtain/submitCurtainOrder',
      method: 'post',
      data: data,
    })
  },
  getCurtainOrder(data){
    return request({
      url: 'group/curtain/getCurtainOrder',
      method: 'get',
      params: data,
    })
  },
  getCurtainOrderInfo(data){
    return request({
      url: 'group/curtain/getCurtainOrderInfo',
      method: 'get',
      params: data,
    })
  },
  getCurtainGroup(data){
    return request({
      url: 'group/curtain/getCurtainGroup',
      method: 'get',
      params: data,
    })
  },
  getCurtainWorker(data){
    return request({
      url: 'group/curtain/getCurtainWorker',
      method: 'get',
      params: data,
    })
  },
  changeCurtainStatus(data){
    return request({
      url: 'group/curtain/changeCurtainStatus',
      method: 'post',
      data: data,
    })
  },
  curtainGrabOrder(data){
    return request({
      url: 'group/curtain/curtainGrabOrder',
      method: 'post',
      data: data,
    })
  },
  curtainComment(data){
    return request({
      url: 'group/curtain/curtainComment',
      method: 'post',
      data: data,
    })
  },
  curtainEditHomeTime(data){
    return request({
      url: 'group/curtain/curtainEditHomeTime',
      method: 'post',
      data: data,
    })
  },
  curtainPayStatus(data){
    return request({
      url: 'group/curtain/curtainPayStatus',
      method: 'post',
      data: data,
    })
  },
  getCurtainOrderCount(data){
    return request({
      url: 'group/curtain/getCurtainOrderCount',
      method: 'get',
      params: data,
    })
  },
  curtainOrderLog(data){
    return request({
      url: 'group/curtain/curtainOrderLog',
      method: 'get',
      params: data,
    })
  },
  resetCurtainOrder(data){
    return request({
      url: 'group/curtain/resetCurtainOrder',
      method: 'post',
      data: data,
    })
  },
  cancelCurtainOrder(data){
    return request({
      url: 'group/curtain/cancelCurtainOrder',
      method: 'post',
      data: data,
    })
  },
  submitCurtainUpload(data){
    return request({
      url: 'group/curtain/submitCurtainUpload',
      method: 'post',
      data: data,
    })
  },
  curtainSort(data){
    return request({
      url: 'group/curtain/curtainSort',
      method: 'post',
      data: data,
    })
  },
  getCurtainOrderDateCount(data){
    return request({
      url: 'group/curtain/getCurtainOrderDateCount',
      method: 'get',
      params: data,
    })
  },
 
  getCurtainOrderPayCount(data){
    return request({
      url: 'group/curtain/getCurtainOrderPayCount',
      method: 'get',
      params: data,
    })
  },
  getWorkerList(data){
    return request({
      url: 'group/curtain/getWorkerList',
      method: 'get',
      params: data,
    })
  },
  getCurtainMapOrder(data){
    return request({
      url: 'group/curtain/getCurtainMapOrder',
      method: 'get',
      params: data,
    })
  },
  changeCurtainWorkerStatus(data){
    return request({
      url: 'group/curtain/changeWorkerStatus',
      method: 'post',
      data: data,
    })
  },
  curtainAddWorker(data){
    return request({
      url: 'group/curtain/curtainAddWorker',
      method: 'post',
      data: data,
    })
  },
  curtainDeleteWorker(data){
    return request({
      url: 'group/curtain/curtainDeleteWorker',
      method: 'post',
      data: data,
    })
  },
  curtainReward(data){
    return request({
      url: 'group/curtain/curtainReward',
      method: 'post',
      data: data,
    })
  },
  curtainRemark(data){
    return request({
      url: 'group/curtain/curtainRemark',
      method: 'post',
      data: data,
    })
  },
}
export default api;


// WEBPACK FOOTER //
// ./src/utils/api.js